// ✅ Auto-generated AppML Tutorial components index

import AppML_API from "./appml_tutorial_components/AppML_API.jsx";
import AppML_API_Reference from "./appml_tutorial_components/AppML_API_Reference.jsx";
import AppML_ASP from "./appml_tutorial_components/AppML_ASP.jsx";
import AppML_Amazon_RDS_SQL from "./appml_tutorial_components/AppML_Amazon_RDS_SQL.jsx";
import AppML_Architecture from "./appml_tutorial_components/AppML_Architecture.jsx";
import AppML_Case_Categories from "./appml_tutorial_components/AppML_Case_Categories.jsx";
import AppML_Case_Customers from "./appml_tutorial_components/AppML_Case_Customers.jsx";
import AppML_Case_Employees from "./appml_tutorial_components/AppML_Case_Employees.jsx";
import AppML_Case_Intro from "./appml_tutorial_components/AppML_Case_Intro.jsx";
import AppML_Case_JSONFile from "./appml_tutorial_components/AppML_Case_JSONFile.jsx";
import AppML_Case_Products from "./appml_tutorial_components/AppML_Case_Products.jsx";
import AppML_Case_Shippers from "./appml_tutorial_components/AppML_Case_Shippers.jsx";
import AppML_Case_Suppliers from "./appml_tutorial_components/AppML_Case_Suppliers.jsx";
import AppML_Case_TextFile from "./appml_tutorial_components/AppML_Case_TextFile.jsx";
import AppML_Case_XMLFile from "./appml_tutorial_components/AppML_Case_XMLFile.jsx";
import AppML_Client from "./appml_tutorial_components/AppML_Client.jsx";
import AppML_Controllers from "./appml_tutorial_components/AppML_Controllers.jsx";
import AppML_Data from "./appml_tutorial_components/AppML_Data.jsx";
import AppML_Databases from "./appml_tutorial_components/AppML_Databases.jsx";
import AppML_Datafiles from "./appml_tutorial_components/AppML_Datafiles.jsx";
import AppML_Forms from "./appml_tutorial_components/AppML_Forms.jsx";
import AppML_Google_Cloud_SQL from "./appml_tutorial_components/AppML_Google_Cloud_SQL.jsx";
import AppML_History from "./appml_tutorial_components/AppML_History.jsx";
import AppML_Home from "./appml_tutorial_components/AppML_Home.jsx";
import AppML_HowTo from "./appml_tutorial_components/AppML_HowTo.jsx";
import AppML_Includes from "./appml_tutorial_components/AppML_Includes.jsx";
import AppML_Lists from "./appml_tutorial_components/AppML_Lists.jsx";
import AppML_Messages from "./appml_tutorial_components/AppML_Messages.jsx";
import AppML_Models from "./appml_tutorial_components/AppML_Models.jsx";
import AppML_PHP from "./appml_tutorial_components/AppML_PHP.jsx";
import AppML_Prototype from "./appml_tutorial_components/AppML_Prototype.jsx";
import AppML_Reference from "./appml_tutorial_components/AppML_Reference.jsx";
import AppML_WebSQL from "./appml_tutorial_components/AppML_WebSQL.jsx";

const AllAppmlTutorialComponents = {
  "<AppML_API />": AppML_API,
  "<AppML_ASP />": AppML_ASP,
  "<AppML_Amazon_RDS_SQL />": AppML_Amazon_RDS_SQL,
  "<AppML_Architecture />": AppML_Architecture,
  "<AppML_Case_Categories />": AppML_Case_Categories,
  "<AppML_Case_Customers />": AppML_Case_Customers,
  "<AppML_Case_Employees />": AppML_Case_Employees,
  "<AppML_Case_Intro />": AppML_Case_Intro,
  "<AppML_Case_JSONFile />": AppML_Case_JSONFile,
  "<AppML_Case_Products />": AppML_Case_Products,
  "<AppML_Case_Shippers />": AppML_Case_Shippers,
  "<AppML_Case_Suppliers />": AppML_Case_Suppliers,
  "<AppML_Case_TextFile />": AppML_Case_TextFile,
  "<AppML_Case_XMLFile />": AppML_Case_XMLFile,
  "<AppML_Client />": AppML_Client,
  "<AppML_Controllers />": AppML_Controllers,
  "<AppML_Data />": AppML_Data,
  "<AppML_Databases />": AppML_Databases,
  "<AppML_Datafiles />": AppML_Datafiles,
  "<AppML_Forms />": AppML_Forms,
  "<AppML_Google_Cloud_SQL />": AppML_Google_Cloud_SQL,
  "<AppML_History />": AppML_History,
  "<AppML_Home />": AppML_Home,
  "<AppML_HowTo": AppML_HowTo,
  "<AppML_Includes />": AppML_Includes,
  "<AppML_Lists />": AppML_Lists,
  "<AppML_Messages />": AppML_Messages,
  "<AppML_Models />": AppML_Models,
  "<AppML_PHP />": AppML_PHP,
  "<AppML_Prototype />": AppML_Prototype,
  "<AppML_Reference />": AppML_Reference,
  "<AppML_WebSQL />": AppML_WebSQL,
};
export default AllAppmlTutorialComponents;
